import React from "react";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import ImageWrapper from "../../components/ImageWrapper";
import challenges from "../../assets/img/challenges.jpg";
import ContactForm from "../../sections/ContactForm";
import Doctor from "../../sections/Doctor";
import invisalign from "../../assets/img/invisalign-benefits.jpg";

export default function Adults() {
  return (
    <>
      <div className="bg-adults w-full h-[70vh] bg-cover bg-bottom flex items-center justify-center">
        <h1 className="text-4xl lg:text-5xl text-white text-center font-extrabold">
          Ортодонтия за възрастни
        </h1>
      </div>
      <div className="page__width my-32 gap-2 flex flex-col items-center justify-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-center text-heading">
          Ортодонтско Лечение за Възрастни
        </h2>
        <p className="text-body text-base w-full lg:w-4/5 lg:text-lg text-center">
          Ортодонтски възрастен пациент наричаме пациенти, при които активният
          скелетен растеж е приключил (над 16г). Ортодонтакото лечение е
          подходящо за всяка възраст, като за разлика от лечението при растящия
          пациент, лечението при възрастните повлиява единствено позицията на
          зъбите, но не и позицията на челюстите. Обикновено придвижването на
          зъбите е по-бавно, отколкото при децата, което може да удължи срока на
          лечението. В зависимост от тежестта на проблема, лечението се провежда
          с помощта на брекети или прозрачни шини/алайнери.
        </p>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row-reverse items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={challenges} className="w-full rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Ролята на Мини Имплантите в Ортодонтията
          </h2>
          <p className="text-base text-body font-normal">
            Често при такива пациенти се използват т.нар. мини импланти (мини
            винтове), които се изплзват с различни цели- цялостно преместване на
            зъбите в зависимост от захапката, корекция на гингивална (венечна)
            усмивка, корекция на оклузален кант (наклонена равнина на зъбите и
            захапката), набиване на прораснали зъби, преместване на зъб към
            мястото на съседен, изваден зъб и др.
          </p>
          <p className="text-base text-body font-normal">
            Пациентите често имат пломби, коронки, пародонтални проблеми,
            липсващи зъби и др, което определя спецификата на лечението.За
            постигане на изключителен естетичен резултат в тази възраст често се
            налага ортодонтското лечение да се последва от възстановителна
            дентална процедура, като композитни или керамични
            възстановявания-бондинг, фасети, корони и т.н.
          </p>

          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <div className="page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper src={invisalign} className="w-full rounded-lg" />
        </div>
        <div className="w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            Лечение с Прозрачни Шини
          </h2>
          <p className="text-base text-body font-normal">
            Прозрачните шини (Invisalign) са индивидуално изработени прозрачни
            шини, които осъществяват зъбни премествания.Зъбните премествания се
            планират изцяло дигитално от лекуващия ортодонт.На всеки 7-10 дни се
            поставя нов комплект шини до приключване на лечението.
          </p>
          <p className="text-base text-body font-normal mt-2">
            Изискване за
            постигане на успешно ортодонтско лечение е да се носят 22 часа в
            денонощието- свалят се по време на хранене и миене на
            зъбите.Задължително условие е след всяко хранене зъбите да бъдат
            прецизно измити с четка, паста за зъби и интердентален конец.
          </p>
          {/* <div className="flex flex-col gap-4 mb-2">
                        <div className="flex gap-4 items-center">
                            <div className="p-4 bg-white shadow-icon rounded-md flex items-center justify-center">
                                <Icon
                                    name="surgery"
                                    className="w-7 h-7 text-brand"
                                />
                            </div>
                            <h3 className="text-2xl font-bold text-heading">
                                Хирургична намеса
                            </h3>
                        </div>
                        <div className="flex flex-col mb-2">
                            <p className="text-base text-body font-normal">
                                В тежки случаи на челюстни несъответствия може
                                да се наложи ортогнатна хирургия за постигане на
                                желания резултат.
                            </p>
                        </div>
                    </div> */}
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div>

      <Doctor name="daliya" />

      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="#">Свържи се с нас</Button>
      </div>
    </>
  );
}
